<div fxLayout="column"  style="position: relative;">
  <div fxLayout="row" fxFlex="100" fxLayoutGap="5px" fxLayoutAlign="start center">
    <button mat-icon-button (click)="initViewStoring()"  matTooltip="Δημιουργία προτύπου πίνακα"><mat-icon class="main-icon">data_saver_on</mat-icon></button>

    <div fxLayout="row" fxLayoutGap="5px" *ngIf="isViewSaving" fxLayoutAlign="start center">
      <mat-form-field>
        <mat-label>Όνομα προτύπου</mat-label>
        <input matInput [(ngModel)]="viewName" />
      </mat-form-field>
      <button mat-icon-button (click)="submitView()" class="main-icon"  matTooltip="Αποθήκευση"><mat-icon>save</mat-icon></button>
      <button mat-icon-button (click)="closeViewSaving()"  matTooltip="Ακύρωση"><mat-icon>close</mat-icon></button>
    </div>
    <button mat-icon-button (click)="loadViews()" class="main-icon" matTooltip="Φόρτωση προτύπων πίνακα"><mat-icon>table</mat-icon></button>
  </div>
<!--  <div fxLayout="row" fxFlex="100" fxLayoutGap="5px">-->
<!--    <button mat-icon-button (click)="initViewStoring()"><mat-icon>save</mat-icon></button>-->

<!--    <div fxLayout="row" fxLayoutGap="5px" *ngIf="isViewSaving" fxLayoutAlign="start center">-->
<!--      <mat-form-field>-->
<!--        <mat-label>Όνομα προτύπου</mat-label>-->
<!--        <input matInput [(ngModel)]="viewName" />-->
<!--      </mat-form-field>-->
<!--      <button mat-icon-button (click)="submitView()"><mat-icon>save</mat-icon></button>-->
<!--      <button mat-icon-button (click)="closeViewSaving()"><mat-icon>close</mat-icon></button>-->
<!--    </div>-->
<!--    <button mat-icon-button (click)="loadViews()"><mat-icon>download</mat-icon></button>-->
<!--  </div>-->

  <div fxLayout="row" fxFlex="100">
  <dx-data-grid [dataSource]="resumes"
                [showBorders]="true"
                [focusedRowEnabled]="true"
                [showColumnLines]="true"
                [showRowLines]="false"
                keyExpr="id"
                [rowAlternationEnabled]="true"
                [allowColumnResizing]="true"
                [columnAutoWidth]="true"
                (onExporting)="onExporting($event)"
                [allowColumnReordering]="true">
    <dxo-state-storing
      [enabled]="true"
      type="custom"
      [customLoad]="loadState"
      [customSave]="saveState">
    </dxo-state-storing>
    <dxo-export
      [enabled]="true"
      [formats]="['pdf', 'xlsx', 'docx', 'csv']"
      [allowExportSelectedData]="true"
    ></dxo-export>
    <dxo-column-chooser [allowSearch]="true" [enabled]="true" [emptyPanelText]="'Σύρτε μια στήλη εδώ για να την αποκρύψετε'" [title]="'Απόκρυψη στηλών'"></dxo-column-chooser>
    <dxo-column-fixing  [enabled]="true"></dxo-column-fixing>
    <dxo-filter-row
      [visible]="showFilterRow"
      [applyFilter]="currentFilter"
    ></dxo-filter-row>
    <dxo-header-filter [visible]="showHeaderFilter" [title]="'Επιλογή όλων'" [textContent]="'Επιλογή'" [texts]="{cancel: 'άκυρο', emptyValue: 'Επιλογή όλων'}"></dxo-header-filter>
    <dxo-search-panel
      [visible]="true"
      [width]="240"
      placeholder="Αναζήτηση..."
    ></dxo-search-panel>
    <dxo-group-panel [emptyPanelText]="'Σύρτε μια στήλη εδώ για να την ομαδοποιήσετε'" [visible]="true"></dxo-group-panel>
    <dxi-column  caption="Τίτλος" dataField="title" [alignment]="'left'"></dxi-column>
    <dxi-column [visible]="false" caption="Δημιουργήθηκε από" dataField="createdBy" [alignment]="'left'"></dxi-column>

    <dxi-column  showWhenGrouped="true" [format]="'dd-MM-yyyy'" caption="Ημερομηνία Δημιουργίας" dataField="createdAt" dataType="date" [alignment]="'left'"></dxi-column>
    <dxi-column  caption="Δημοσιευμένη" dataField="isPublished" [width]="50" ></dxi-column>
    <dxi-column

      *ngIf="!isReport"
      [alignment]="'left'"
      dataField="id"
      caption="Ενέργειες"
      [allowFiltering]="false"
      [allowSorting]="false"
      cellTemplate="cellTemplate"
    ></dxi-column>
    <dxi-column
      *ngIf="isReport"
      [width]="70"
      [alignment]="'left'"
      dataField="id"
      caption="Ενέργειες"
      [allowFiltering]="false"
      [allowSorting]="false"
      cellTemplate="cellTemplate-report"
    ></dxi-column>

    <dxo-paging [pageSize]="200"> </dxo-paging>
    <div *dxTemplate="let data of 'cellTemplate'" fxLayout="row" fxLayoutGap="5px" >
      <button [disabled]="isLoading" mat-icon-button class="internal-icons" (click)="previewForm(data)" matTooltip="Προεπισκόπηση"><mat-icon>visibility</mat-icon></button>
      <button [disabled]="isLoading" mat-icon-button class="internal-icons" (click)="editForm(data)" matTooltip="Επεξεργασία"><mat-icon>edit</mat-icon></button>
          <button [disabled]="isLoading" mat-icon-button class="internal-icons" (click)="copy(data)" matTooltip="Αντιγραφή"><mat-icon>content_copy</mat-icon></button>
      <button [disabled]="isLoading" mat-icon-button class="internal-icons" (click)="copyLink(data)" matTooltip="Αντιγραφή συνδέσμου"><mat-icon>link</mat-icon></button>
      <button [disabled]="isLoading" mat-icon-button class="internal-icons" (click)="deleteForm(data)" matTooltip="Διαγραφή"><mat-icon>delete</mat-icon></button>
    </div>

    <div *dxTemplate="let data of 'cellTemplate-report'" fxLayout="row" fxLayoutGap="5px" >
      <button mat-icon-button class="internal-icons" (click)="navigateToResumeDetails(data)" matTooltip="Προεπισκόπηση"><mat-icon>visibility</mat-icon></button>
    </div>
  </dx-data-grid>
  </div>
</div>


  <mat-card *ngIf="views.isDisplaying"
            cdkDrag fxLayout="column" style="z-index: 10; overflow-y:auto; background-color: white; position: absolute; top:20%; right: 5px; width: 400px; height: 250px;">
    <mat-card-title>
      <div fxLayout="row" fxLayoutAlign="start center" style="cursor: pointer">
        <label fxFlex="100">Εμφανίσεις πίνακα</label>
        <button mat-icon-button (click)="hideViews()"><mat-icon>close</mat-icon></button>
      </div>
    </mat-card-title>

    <mat-card-content>
      <div fxLayout="column" *ngIf="views.isLoading" style="margin-top: 15px;">
        <div fxLayout="row" fxFlex="100" fxLayoutAlign="center center">
          <app-loading></app-loading>
        </div>
      </div>
      <div fxLayout="column" fxFlex="100" *ngIf="!views.isLoading">
        <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center"
             style="padding: 5px; border-bottom: 1px solid lightgray;" *ngFor="let view of views.records">
          <label fxFlex="100">{{view.name}}</label>
          <button  [disabled]="shouldBeDisabled()" mat-icon-button (click)="applyView(view.state)"><mat-icon>check</mat-icon></button>
          <button [class.spinner]="views.isUpdating" [disabled]="shouldBeDisabled()" mat-icon-button><mat-icon>update</mat-icon></button>
          <button [class.spinner]="views.isDeleting" [disabled]="shouldBeDisabled()" mat-icon-button (click)="deleteView(view.id)"><mat-icon>delete</mat-icon></button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

